import React from "react";
import {
  Header,
  LogoSection,
  WindSongFooter
} from "../components";
function DestinationPlatypusBayPeelIsland() {
  return (
    <div className="text-gray-600">
      <Header />
      <LogoSection />
        <h1 className="text-center text-5xl mt-48">DestinationPlatypusBayPeelIsland Page</h1>
      <WindSongFooter />
    </div>
  );
}

export default DestinationPlatypusBayPeelIsland;

